export const taskStatusNameColor = (status: string) => {
    switch (status.toLowerCase()) {
        case "not yet started":
        case "not yet due":
        case "saved":
            return "info";
        case "submitted pending co-signature":
        case "to be sent":
        case "returned for review":
        case "pending follow up":
        case "reopened":
        case "pending addendum":
            return "warning";
        case "submitted with signature":
        case "export ready":
        case "exported":
        case "sent to physician":
        case "returned with physician signature":
        case "completed":
            return "success";
        default:
            return "danger";
    }
};
